import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import * as _ from "lodash";

interface Props
{
    onClose: () => void;
}

import './CloseButton.scss';


export default class CloseButton extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {onClose} = this.props;

        return <button styleName={'close-button'} onClick={onClose}>

            <i className="fas fa-times" />

        </button>
    }
}



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/modals/CloseButton.tsx